export const tailwindConfig = {
  fontFamily: {
    sans: ['Rubik'],
  },
  extend: {
    colors: {
      navyPrime: '#002953',
      primeval: {
        50: '#fef7ee',
        100: '#feedd6',
        200: '#fbd7ad',
        300: '#f9ba78',
        400: '#f59242',
        500: '#f2731c',
        600: '#e35913',
        700: '#bc4212',
        800: '#963616',
        900: '#792f15',
        950: '#411509',
      },
      secondary: {
        50: '#e9fbff',
        100: '#cef5ff',
        200: '#a7efff',
        300: '#6beaff',
        400: '#26d8ff',
        500: '#00b4ff',
        600: '#008aff',
        700: '#006fff',
        800: '#0060e6',
        900: '#0055b3',
        950: '#002953'
      },
      shade: {
        50: '#fffbec',
        100: '#fff6d3',
        200: '#ffe9a5',
        300: '#ffd66d',
        400: '#ffb932',
        500: '#ffa10a',
        600: '#ff8900',
        700: '#cc6402',
        800: '#a14d0b',
        900: '#82410c',
        950: '#461f04'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce6',
        200: '#bbf7cf',
        300: '#85f0aa',
        400: '#49df7d',
        500: '#23d160',
        600: '#15a447',
        700: '#14813b',
        800: '#166533',
        900: '#14532c',
        950: '#052e15',
      },
      info: {
        50: '#f0f8ff',
        100: '#e0effe',
        200: '#bbe0fc',
        300: '#7fc7fa',
        400: '#3bacf5',
        500: '#209cee',
        600: '#0572c4',
        700: '#065b9e',
        800: '#094d83',
        900: '#0e426c',
        950: '#092948',
      },
      warning: {
        50: '#fefbe8',
        100: '#fff7c2',
        200: '#ffec89',
        300: '#ffdd57',
        400: '#fdc412',
        500: '#ecaa06',
        600: '#cc8202',
        700: '#a35b05',
        800: '#86480d',
        900: '#723b11',
        950: '#431d05',
      },
      danger: {
        50: '#ffefef',
        100: '#ffdcdc',
        200: '#ffbfbf',
        300: '#ff9292',
        400: '#ff5454',
        500: '#ff1f1f',
        600: '#ff0000',
        700: '#db0000',
        800: '#b40000',
        900: '#940808',
        950: '#520000',
      },
      leftArrow: '#111111',
    }, 
    height: {
      '30': '120px'
    } 
  }
};